// -----------------------------------------------------------------------------
export class StorageValue {
  private readonly _value: string;

  // ---------------------------------------------------------------------------
  public constructor(value: string) {
    this._value = value;
  }

  // ---------------------------------------------------------------------------
  public get raw(): string | null {
    return this._value;
  }

  // ---------------------------------------------------------------------------
  public asBool(): boolean {
    if (!this._value) {
      return false;
    }

    return this._value.toLowerCase() === 'true';
  }

  // ---------------------------------------------------------------------------
  public asInt(): number {
    if (!this._value) {
      return NaN;
    }

    return parseInt(this._value, 10);
  }

  // ---------------------------------------------------------------------------
  public asObject(): object {
    if (!this._value) {
      return null;
    }

    try {
      const obj = JSON.parse(this._value);
      return obj;
    } catch (e) {
      return null;
    }
  }

  // ---------------------------------------------------------------------------
  public asArray(): any[] {
    try {
      const obj = JSON.parse(this._value);
      return obj;
    } catch (e) {
      return null;
    }
  }

  // ---------------------------------------------------------------------------
  public isNull(): boolean {
    return this._value === null;
  }
}
